import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import API from "../../utils/API";

function Clients() {
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("yc_usr_dt_ls"));
        if (user && ["MECANICO", "COMPRADOR"].includes(user.role)) {
            window.location.href = '/services';
        }
    }, []);

    useEffect(() => {
        if (!localStorage.getItem('yc_usr_dt_ls')) {
            window.location.href = '/login';
        }
        Swal.fire({
            title: "Carregando...",
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            willOpen: () => Swal.showLoading(),
        });
        API.getClients(API.cancelToken()).then((res) => {
            const originData = res.data.map((item) => ({
                client_id: item.client_id,
                name: item.name,
                email: item.email,
                phone_number: item.phone_number,
                address_city: item.address_city,
                cpf: item.cpf,
            }));
            setData(originData);
            Swal.close();
        });
    }, []);

    const filteredData = data.filter((item) => {
        if (!searchQuery) return true;
        const q = searchQuery.toLowerCase();
        return Object.values(item).some((value) =>
            String(value).toLowerCase().includes(q)
        );
    });

    return (
        <div className="flex w-full h-full pt-8 px-20 pb-24 items-center gap-8 self-stretch max-md:px-4">
            <div className="flex w-full h-auto py-6 px-11 flex-col items-center gap-6 self-stretch bg-white rounded-lg shadow max-md:px-4">
                {/* Header */}
                <div className="flex w-full justify-between items-center flex-wrap gap-4">
                    <div>
                        <h1 className="text-2xl font-semibold text-gray-900">Clientes</h1>
                        <p className="text-sm text-gray-500 mt-1">{data.length} cliente{data.length !== 1 ? 's' : ''} cadastrado{data.length !== 1 ? 's' : ''}</p>
                    </div>
                    <div className="relative">
                        <svg className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                        </svg>
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            placeholder="Pesquisar..."
                            className="border border-gray-300 rounded-lg pl-9 pr-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#389E0D] focus:border-transparent w-64"
                        />
                    </div>
                </div>

                {/* Table */}
                <div className="w-full overflow-x-auto rounded-lg border border-gray-200">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Cliente</th>
                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Contato</th>
                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Cidade</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {filteredData.length > 0 ? (
                                filteredData.map((row) => (
                                    <tr key={row.client_id} className="hover:bg-gray-50 transition-colors">
                                        <td className="px-4 py-3">
                                            <div className="flex items-center gap-3">
                                                <div className="flex-shrink-0 h-9 w-9 rounded-full bg-[#389E0D] bg-opacity-10 flex items-center justify-center text-sm font-semibold text-[#389E0D]">
                                                    {row.name?.[0]?.toUpperCase() || "?"}
                                                </div>
                                                <div>
                                                    <p className="text-sm font-medium text-gray-900">{row.name}</p>
                                                    <p className="text-xs text-gray-400">{row.cpf || `ID ${row.client_id}`}</p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="px-4 py-3">
                                            <div>
                                                <div className="flex items-center gap-1.5 text-sm text-gray-700">
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 text-gray-400 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                                                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                                    </svg>
                                                    <span className="truncate max-w-[200px]">{row.email || "-"}</span>
                                                </div>
                                                <div className="flex items-center gap-1.5 text-xs text-gray-400 mt-1">
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 text-gray-400 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                                                        <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                                    </svg>
                                                    <span>{row.phone_number || "-"}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="px-4 py-3">
                                            {row.address_city ? (
                                                <div className="flex items-center gap-1.5 text-sm text-gray-600">
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 text-gray-400 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                                                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                                    </svg>
                                                    {row.address_city}
                                                </div>
                                            ) : (
                                                <span className="text-sm text-gray-300">-</span>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="text-center py-8 text-gray-400 text-sm">
                                        Nenhum cliente encontrado.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default Clients;
